import { useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetSearchTagsQuery from '@/graphql/contracts/getSearchTags.query.gql';
import { GetSearchTags, GetSearchTagsVariables } from '@/graphql/contracts/_generated_/getSearchTags.query';
import { SEARCH_TAGS_TO_SHOW } from '@/config/common.config';
import { notificationService } from '@/services/notification/notification.client';

export default function useGetSearchTags() {
  const [_getSearchTags, { data, loading }] = useLazyQuery<GetSearchTags, GetSearchTagsVariables>(
    GetSearchTagsQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      fetchPolicy: 'cache-and-network'
    }
  );

  const getSearchTags = (count: number) => {
    _getSearchTags({
      variables: {
        count
      }
    });
  };

  useEffect(() => {
    getSearchTags(SEARCH_TAGS_TO_SHOW);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    getSearchTags,
    searchTags: data?.searchTags || [],
    isLoadingTags: loading
  } as const;
}
